enum CommonCssClass {
    NoTransition = 'g-notransition',
    AnimFade = 'g-anim-fade',
    AnimFadeIn = 'g-anim-fade_in',
    Hidden = 'g-hidden',
    ScrollMeasure = 'scroll-measure',
}

export default CommonCssClass;
